import { render, staticRenderFns } from "./BankTransferAccountNumber.vue?vue&type=template&id=ead925c0&"
import script from "./BankTransferAccountNumber.vue?vue&type=script&lang=ts&"
export * from "./BankTransferAccountNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports